import { ArrowBack, ArrowForward,CalendarMonthOutlined,} from "@mui/icons-material";
import { IconButton, List, ListItem, ListItemText, MenuItem, Popover, Select, Typography,} from "@mui/material";
import { Box } from "@mui/system";
import { DateCalendar, LocalizationProvider,} from "@mui/x-date-pickers";
import { DateRangeCalendar } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { addDays, endOfDay, format, startOfDay, subDays } from "date-fns";
import { addMonths, addWeeks, endOfMonth, endOfWeek, startOfMonth, startOfWeek, subMonths, subWeeks,isWithinInterval,} from "date-fns";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { filterEntities } from "../../apis/apiService";
import { toast } from "react-toastify";
import { useTheme } from "../../ThemeContext";

const predefinedRanges = [
  { label: "Day", 
    startDate: new Date(), 
    endDate: new Date() 
  },
  {
    label: "Week",
    startDate: startOfWeek(new Date()),
    endDate: endOfWeek(new Date()),
  },
  {
    label: "Month",
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    endDate: new Date(),
  },
  {
    label: "Range",
  },
  {
    label: "Project Span",
  },
];

const months = Array.from({ length: 12 }, (_, i) => ({
  label: format(new Date(2024, i, 1), "MMMM"),
  value: i,
}));

export const CustomCalendar = ({
  selectionRange,
  setSelectionRange,
  projectSpan,
  setProjectSpan,
  clearFilter,
  handleClear,
  onApplyTransformedData,
  total_log_hours_refetch,
  refetch,
  setClearFilter,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const { isDarkMode } = useTheme();
  const [showMonthPicker, setShowMonthPicker] = useState(
    projectSpan === "month" ? true : false
  );
  const [showWeekPicker, setShowWeekPicker] = useState(
    projectSpan === "week" ? true : false
  );
  const [showDatePicker, setshowDatepicker] = useState(
    projectSpan === "today" ? true : false
  );
  const [showDateRangePicker, setShowDateRangePicker] = useState(
    projectSpan === "range" ? true : false
  );
  const [showProjectSpan, setShowProjectSpan] = useState(
    projectSpan === "project_span" ? true : false
  );
  const [selectedRange, setSelectedRange] = useState([null, null]);
  const [tempSelectionRange, setTempSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const handleSelect = (ranges) => {
    const key = Object.keys(ranges)[0];
    const selectedRange = ranges[key];

    if (!selectedRange) return;

    setTempSelectionRange({
      startDate: selectedRange.startDate || new Date(),
      endDate: selectedRange.endDate || new Date(),
      key: key,
    });
  };

  // const handleApply = () => {
  //   setSelectionRange(tempSelectionRange);
  //   setProjectSpan("range");
  //   setOpen(false); // Close the popover after applying the date range
  // };
  const handleApply = () => {
    if (selectedRange[0] && selectedRange[1]) {
      const startDate = new Date(selectedRange[0]);
      const endDate = new Date(selectedRange[1]);

      setSelectionRange({
        startDate: startDate,
        endDate: endDate,
        key: "selection",
      });

      setProjectSpan("range");
      setOpen(false);
    }
  };
  const handleSetCurrentDate = () => {
    const today = new Date();
    setSelectionRange({ startDate: today, endDate: today, key: "selection" });
    setProjectSpan("today");
    setOpen(false);
  };

  const handleSetCurrentWeek = () => {
    const today = new Date();
    const start = startOfWeek(today);
    const end = endOfWeek(today);
    setSelectionRange({ startDate: start, endDate: end, key: "selection" });
    setProjectSpan("week");
    setOpen(false);
  };

  const handleSetCurrentMonth = () => {
    const today = new Date();
    const start = startOfMonth(today);
    const end = endOfMonth(today);
    setSelectionRange({ startDate: start, endDate: end, key: "selection" });
    setProjectSpan("month");
    setOpen(false);
  };
  const handlePredefinedSelect = (range) => {
    if (!range.label || typeof range.label !== "string") return;

    if (range.label === "Month") {
      setShowMonthPicker(true);
      setShowWeekPicker(false);
      setShowDateRangePicker(false);
      setshowDatepicker(false);
      setShowProjectSpan(false);
    } 
    else if (range.label === "Week") {
      setShowWeekPicker(true);
      setShowMonthPicker(false);
      setshowDatepicker(false);
      setShowDateRangePicker(false);
      setShowProjectSpan(false);
    } 
    else if (range.label === "Range") {
      setShowDateRangePicker(true);
      setShowWeekPicker(false);
      setShowMonthPicker(false);
      setshowDatepicker(false);
      setShowProjectSpan(false);
    } 
    else if (range.label === "Day") {
      setShowDateRangePicker(false);
      setshowDatepicker(true);
      setShowWeekPicker(false);
      setShowMonthPicker(false);
      setShowProjectSpan(false);
    } 
    else if (range.label === "Project Span") {
      setProjectSpan("project_span");
      setShowProjectSpan(true);
      setShowMonthPicker(false);
      setShowWeekPicker(false);
      setShowDateRangePicker(false);
      setshowDatepicker(false);
      setSelectionRange({
        startDate: null,
        endDate: null,
        key: "selection",
      });
      // Removing setOpen(false) so it doesn't close and allows user to see the text.
      // But maybe we should call triggerFilter if needed? It already clears selection.
    } 
    else {
      setShowMonthPicker(false);
      setShowWeekPicker(false);
      setShowDateRangePicker(false);
      setshowDatepicker(false);
      setShowProjectSpan(false);
      setSelectionRange({
        startDate: range.startDate,
        endDate: range.endDate,
        key: "selection",
      });
    }

    // // ✅ Ensure selecting "Day" also opens the Week Picker
    // if (range.label === "Day") {
    //   setProjectSpan("today");
    //   setShowWeekPicker(true); // ✅ Show Week Picker when "Day" is selected
    //   setShowMonthPicker(false);
    //   setShowDateRangePicker(false);
    // }

    setOpen(true);
  };

  const handleMonthSelect = (month) => {
    setSelectedMonth(month);
    setSelectionRange({
      startDate: startOfMonth(new Date(selectedYear, month, 1)),
      endDate: endOfMonth(new Date(selectedYear, month, 1)),
      key: "selection",
    });
    setProjectSpan("month");
    setOpen(false);
  };

  const handleDateChange = (newRange) => {
    setSelectedRange(newRange);

    if (newRange[0] && newRange[1]) {
      console.log(
        `From Date: ${selectedRange}, To Date: ${dayjs(newRange[1]).format(
          "DD-MM-YYYY"
        )}`
      );
    }
  };

  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 9; // 10 years back
  const maxYear = currentYear;

  const handleWeekSelect = (date) => {
    const start = startOfWeek(date);
    const end = endOfWeek(date);
    setSelectionRange({ startDate: start, endDate: end, key: "selection" });
    setOpen(false);
    setProjectSpan("week");
  };

  const handleDateSelect = (date) => {
    setSelectionRange({
      startDate: date,
      endDate: date,
      key: "selection",
    });
    setProjectSpan("today");
    setOpen(false); // Close the popover after selection
  };

  const getLatestFilter = () => {
    try {
      const latestFilter = sessionStorage.getItem("timesheet_filter");
      return latestFilter ? JSON.parse(latestFilter) : null;
    } catch (e) {
      // console.error("Failed to parse session filter:", e);
      return null;
    }
  };

  const triggerFilterWithUpdatedDates = async (startDate, endDate) => {
    const sessionFilter = getLatestFilter();

    if (!sessionFilter) {
      refetch();
      total_log_hours_refetch();
      return;
    }
    const isProjectSpan = projectSpan === "project_span";

    const updatedData = {
      ...sessionFilter,
      from_date: isProjectSpan
        ? null
        : format(new Date(startDate), "yyyy-MM-dd"),
      to_date: isProjectSpan ? null : format(new Date(endDate), "yyyy-MM-dd"),
    };

    // const updatedData = {
    //   ...sessionFilter,
    //   from_date: format(new Date(startDate), "yyyy-MM-dd"),
    //   to_date: format(new Date(endDate), "yyyy-MM-dd"),
    // };

    try {
      const response = await filterEntities("timesheet/filter", updatedData); // ✅ Use full updated payload

      if (response?.session_data) {
        const { key, value } = response.session_data;
        sessionStorage.setItem(key, JSON.stringify(value));
      }

      sessionStorage.setItem("timesheet_filter", JSON.stringify(updatedData)); // ✅ Save the updated filter

      onApplyTransformedData(response);
    } catch (error) {
      if (error?.message !== "No filtered data found") {
        toast.error(error?.message || "Filter failed");
      }
      onApplyTransformedData([]);
      // console.error("Calendar filter error:", error);
    }
  };

  useEffect(() => {
    sessionStorage.removeItem("timesheet_filter");
    setClearFilter(false);
  }, []);

  // const handlePrevPeriod = () => {
  //   // if (clearFilter) {
  //   //   handleClear();
  //   // }

  //   if (projectSpan === "month") {
  //     setSelectionRange((prev) => ({
  //       startDate: startOfMonth(subMonths(prev.startDate, 1)),
  //       endDate: endOfMonth(subMonths(prev.startDate, 1)),
  //       key: "selection",
  //     }));
  //   } else if (projectSpan === "today") {
  //     setSelectionRange((prev) => ({
  //       startDate: startOfDay(subDays(prev.startDate, 1)),
  //       endDate: endOfDay(subDays(prev.startDate, 1)),
  //       key: "selection",
  //     }));
  //   } else {
  //     setSelectionRange((prev) => ({
  //       startDate: subWeeks(prev.startDate, 1),
  //       endDate: subWeeks(prev.endDate, 1),
  //       key: "selection",
  //     }));
  //   }
  // };
  const handlePrevPeriod = () => {
    let newStartDate, newEndDate;

    if (projectSpan === "month") {
      newStartDate = startOfMonth(subMonths(selectionRange.startDate, 1));
      newEndDate = endOfMonth(subMonths(selectionRange.startDate, 1));
    } else if (projectSpan === "today") {
      newStartDate = startOfDay(subDays(selectionRange.startDate, 1));
      newEndDate = endOfDay(subDays(selectionRange.startDate, 1));
    } else {
      newStartDate = subWeeks(selectionRange.startDate, 1);
      newEndDate = subWeeks(selectionRange.endDate, 1);
    }

    setSelectionRange({
      startDate: newStartDate,
      endDate: newEndDate,
      key: "selection",
    });

    triggerFilterWithUpdatedDates(newStartDate, newEndDate);
  };
  // const handleNextPeriod = () => {
  //   // if (clearFilter) {
  //   //   handleClear();
  //   // }
  //   if (projectSpan === "month") {
  //     setSelectionRange((prev) => ({
  //       startDate: startOfMonth(addMonths(prev.startDate, 1)),
  //       endDate: endOfMonth(addMonths(prev.startDate, 1)),
  //       key: "selection",
  //     }));
  //   } else if (projectSpan === "today") {
  //     setSelectionRange((prev) => ({
  //       startDate: startOfDay(addDays(prev.startDate, 1)),
  //       endDate: endOfDay(addDays(prev.startDate, 1)),
  //       key: "selection",
  //     }));
  //   } else {
  //     setSelectionRange((prev) => ({
  //       startDate: addWeeks(prev.startDate, 1),
  //       endDate: addWeeks(prev.endDate, 1),
  //       key: "selection",
  //     }));
  //   }
  // };

  const handleNextPeriod = () => {
    let newStartDate, newEndDate;

    if (projectSpan === "month") {
      newStartDate = startOfMonth(addMonths(selectionRange.startDate, 1));
      newEndDate = endOfMonth(addMonths(selectionRange.startDate, 1));
    } else if (projectSpan === "today") {
      newStartDate = startOfDay(addDays(selectionRange.startDate, 1));
      newEndDate = endOfDay(addDays(selectionRange.startDate, 1));
    } else {
      newStartDate = addWeeks(selectionRange.startDate, 1);
      newEndDate = addWeeks(selectionRange.endDate, 1);
    }

    setSelectionRange({
      startDate: newStartDate,
      endDate: newEndDate,
      key: "selection",
    });

    triggerFilterWithUpdatedDates(newStartDate, newEndDate);
  };

  return (
    <Box display="flex" alignItems="center" gap={2}>
      {!(projectSpan === "range" || projectSpan === "project_span") && (
        <IconButton onClick={handlePrevPeriod}>
          <ArrowBack />
        </IconButton>
      )}

      <IconButton onClick={() => setOpen(true)}>
        <CalendarMonthOutlined />
      </IconButton>
      <Typography
        variant="body1"
        onClick={() => setOpen(true)}
        sx={{
          cursor: "pointer",
          fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" },
          whiteSpace: "nowrap",
          display: "flex",
          alignItems: "center",
          lineHeight: 1,
        }}
      >
        {projectSpan === "today" ? (
          <>{format(selectionRange.startDate, "MMM d, yyyy")}</>
        ) : projectSpan === "project_span" ? (
          "Project Span"
        ) : (
          <>
            {format(selectionRange.startDate, "MMM d, yyyy")} -{" "}
            {format(selectionRange.endDate, "MMM d, yyyy")}
          </>
        )}
      </Typography>

      {!(projectSpan === "range" || projectSpan === "project_span") && (
        <IconButton onClick={handleNextPeriod}>
          <ArrowForward />
        </IconButton>
      )}

      {/* Popover for Date Picker or Month Picker */}
      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchorReference="none"
        PaperProps={{
          style: {
            width: "auto", // ✅ Auto-adjust width
            minWidth: "400px", // ✅ Set a minimum width
            maxWidth: "900px", // ✅ Set a maximum width if needed
            padding: "10px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            // flexWrap: "wrap", // ✅ Allow it to wrap content
          },
        }}
      >
        {/* Left Panel: Predefined Views */}
        <Box
          sx={{
            width: "150px",
            borderRight: "1px solid #ddd",
            padding: "10px",
          }}
        >
          {/* <Typography variant="h6" sx={{ marginBottom: 1 }}>
                Select Range
              </Typography> */}
          <List>
            {predefinedRanges.map((range, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handlePredefinedSelect(range)}
                sx={{
                  cursor: "pointer",
                  userSelect: "none",
                  "& *": { cursor: "pointer" },
                  borderBottom:
                    (range.label === "Month" && showMonthPicker) ||
                    (range.label === "Week" && showWeekPicker) ||
                    (range.label === "Day" && showDatePicker) ||
                    (range.label === "Range" && showDateRangePicker) ||
                    (range.label === "Project Span" && showProjectSpan)
                      ? "3px solid rgba(18, 183, 159, 1)" // ✅ Green underline for active
                      : "none",
                }}
              >
                <ListItemText
                  primary={range.label}
                  sx={{
                    pointerEvents: "none",
                    color:
                      (range.label === "Month" && showMonthPicker) ||
                      (range.label === "Week" && showWeekPicker) ||
                      (range.label === "Day" && showDatePicker) ||
                      (range.label === "Range" && showDateRangePicker) ||
                      (range.label === "Project Span" && showProjectSpan)
                        ? "rgba(18, 183, 159, 1)" // ✅ Green text for active
                        : "inherit",
                    "& .MuiTypography-root": {
                      fontWeight:
                        (range.label === "Month" && showMonthPicker) ||
                        (range.label === "Week" && showWeekPicker) ||
                        (range.label === "Day" && showDatePicker) ||
                        (range.label === "Range" && showDateRangePicker) ||
                        (range.label === "Project Span" && showProjectSpan)
                          ? "bold" // ✅ Bold text for active
                          : "normal",
                    }
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>

        {/* Right Panel: Date Picker OR Month Picker */}
        <Box sx={{ flexGrow: 1, padding: "10px" }}>
          {showMonthPicker ? (
            <div className="container">
              {/* Year Selection */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                {/* Previous Year Button (Disabled if selectedYear == minYear) */}
                <IconButton
                  onClick={() => setSelectedYear((prev) => prev - 1)}
                  disabled={selectedYear === minYear}
                  style={{
                    cursor:
                      selectedYear === minYear ? "not-allowed" : "pointer",
                  }}
                >
                  <ArrowBack />
                </IconButton>

                {/* Year Dropdown */}
                <Select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                  // className="form-select w-auto"
                >
                  {Array.from({ length: 10 }, (_, i) => {
                    const year = minYear + i;
                    return (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    );
                  })}
                </Select>

                {/* Next Year Button (Disabled if selectedYear == maxYear) */}
                <IconButton
                  onClick={() => setSelectedYear((prev) => prev + 1)}
                  disabled={selectedYear === maxYear}
                  style={{
                    cursor:
                      selectedYear === maxYear ? "not-allowed" : "pointer",
                  }}
                >
                  <ArrowForward />
                </IconButton>
              </div>

              {/* Month Selection */}
              <div className="row g-3">
                {months.map((month) => (
                  <div className="col-3" key={month.value}>
                    <Box
                      className="d-flex p-2 align-items-center justify-content-center rounded"
                      sx={{
                        cursor: "pointer",
                        height: "45px",
                        backgroundColor:
                          selectedMonth === month.value
                            ? "rgba(18, 183, 159, 1)"
                            : "transparent",
                        color: selectedMonth === month.value ? "#fff" : (isDarkMode ? "#fff" : "#000"),
                        transition: "0.3s",
                        border: "1px solid transparent",
                        "&:hover": {
                          backgroundColor:
                            selectedMonth === month.value
                              ? "rgba(18, 183, 159, 1)"
                              : "rgba(18, 183, 159, 0.1)",
                          borderColor: selectedMonth === month.value ? "transparent" : "rgba(18, 183, 159, 1)",
                        },
                      }}
                      onClick={() => handleMonthSelect(month.value)}
                    >
                      <Typography sx={{ fontSize: "0.85rem", fontWeight: selectedMonth === month.value ? "600" : "400", textAlign: "center" }}>
                        {month.label}
                      </Typography>
                    </Box>
                  </div>
                ))}
                <div className="col-12">
                  <div className="d-flex  mt-2 align-items-center justify-content-between gap-5">
                    <p className=" enterHourse" style={{ cursor: "pointer" }} onClick={handleSetCurrentMonth}>
                      current Month
                    </p>
                    {/* <p
                      className=" enterHourse"
                      onClick={() => handleDateSelect(selectionRange.startDate)}
                    >
                      {" "}
                      ok
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          ) : showWeekPicker ? (
            <div className="col-12">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateCalendar
                  value={selectionRange.startDate}
                  onChange={handleWeekSelect}
                  slots={{
                    day: (dayProps) => {
                      const { day, outsideCurrentMonth, ...other } = dayProps;
                      const isSelected =
                        !outsideCurrentMonth &&
                        selectionRange.startDate &&
                        selectionRange.endDate &&
                        isWithinInterval(day, {
                          start: startOfDay(selectionRange.startDate),
                          end: endOfDay(selectionRange.endDate),
                        });

                      return (
                        <PickersDay
                          {...other}
                          outsideCurrentMonth={outsideCurrentMonth}
                          day={day}
                          sx={{
                            ...(isSelected && {
                              backgroundColor: "rgba(18, 183, 159, 1) !important",
                              color: "#fff !important",
                            }),
                          }}
                        />
                      );
                    },
                  }}
                  sx={{
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    color: isDarkMode ? "#fff" : "rgba(18, 183, 159, 1)",
                    borderRadius: 2,
                    "& .MuiPickersCalendarHeader-label": {
                      fontWeight: "bold",
                      color: "rgba(18, 183, 159, 1)",
                      fontSize: "1.1rem",
                    },
                    "& .MuiPickersDay-root": {
                      color: isDarkMode ? "#fff" : "#111",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "rgba(18, 183, 159, 1) !important",
                      color: "#fff",
                    },
                  }}
                />
              </LocalizationProvider>
              <div className="d-flex  mt-2 align-items-center justify-content-between gap-5">
                <p className=" enterHourse" style={{ cursor: "pointer" }} onClick={handleSetCurrentWeek}>
                  current Week
                </p>
                {/* <p
                  className=" enterHourse"
                  // onClick={}
                >
                  {" "}
                  ok
                </p> */}
              </div>
            </div>

          ) : showDatePicker ? (
            <div className="col-12 ">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateCalendar
                  value={selectionRange.startDate}
                  // onChange={(date) => {
                  //   setSelectionRange({
                  //     startDate: date,
                  //     endDate: date,
                  //     key: "selection",
                  //   });
                  // }}
                  onChange={handleDateSelect}
                  sx={{
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    color: isDarkMode ? "#fff" : "rgba(18, 183, 159, 1)",
                    borderRadius: 2,
                    "& .MuiPickersCalendarHeader-label": {
                      fontWeight: "bold",
                      color: "rgba(18, 183, 159, 1)",
                      fontSize: "1.1rem",
                    },
                    "& .MuiPickersDay-root": {
                      color: isDarkMode ? "#fff" : "#111",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "rgba(18, 183, 159, 1) !important",
                      color: "#fff",
                    },
                    "& .MuiPickersDay-root.Mui-selected": {
                      backgroundColor: "#ff8800",
                      color: "#fff",
                    },
                  }}
                />
              </LocalizationProvider>
              
              {/* <div className=" col-12"> */}
              <div className="d-flex  mt-2 align-items-center justify-content-between gap-5">
                <p className=" enterHourse" style={{ cursor: "pointer" }} onClick={handleSetCurrentDate}>
                  Today
                </p>
                {/* <p
                  className=" enterHourse"
                  onClick={() => handleDateSelect(selectionRange.startDate)}
                >
                  {" "}
                  ok
                </p> */}
              </div>
              {/* </div> */}
            </div>
          ) : showDateRangePicker ? (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateRangeCalendar"]}>
                    <DateRangeCalendar
                      value={selectedRange}
                      onChange={handleDateChange}
                    />
                  </DemoContainer>
                </LocalizationProvider>

                {/* Apply Button */}
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    className="add_btn"
                    onClick={handleApply}
                    sx={{ alignSelf: "flex-end", mt: 1 }}
                  >
                    Apply
                  </button>
                </div>
              </Box>
          ) : showProjectSpan ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                padding: "20px",
                width: "320px",
              }}
            >
              <Typography variant="h6" color="textSecondary">
                Viewing Entire Project Span
              </Typography>
              <button
                className="add_btn mt-4"
                onClick={() => setOpen(false)}
              >
                Done
              </button>
            </Box>
          ) : null}
        </Box>
      </Popover>
    </Box>
  );
};
